import React from 'react';
import { WttpQuestionnaireResponsesData } from 'src/components/wttp/questionnaire-responses/list/types';
import { AssignModal } from './assign-modal';
import { WttpQuestionnaireResponsesDocument } from 'src/graphql/generated/graphql';

export enum WttpQuestionnaireResponseAction {
  Assign = 'reassign-user',
}

export const ActionModals = ({
  action,
  onClose,
  questionnaireResponse,
  onActionFinished,
}: {
  action: WttpQuestionnaireResponseAction;
  onClose: () => void;
  onSubmitted?: (action: WttpQuestionnaireResponseAction) => void;
  questionnaireResponse: WttpQuestionnaireResponsesData;
  onActionFinished?: (action: WttpQuestionnaireResponseAction) => void;
}) => {
  const onFinished = () => {
    onActionFinished?.(action);
    onClose();
  };

  return (
    <>
      {action === WttpQuestionnaireResponseAction.Assign && (
        <AssignModal
          questionnaireResponse={questionnaireResponse}
          onClose={onFinished}
          refetchQueries={[WttpQuestionnaireResponsesDocument]}
        />
      )}
    </>
  );
};
